var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 10,
    viewBox: "0 0 12 10",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4398 0.258277C10.7666 -0.078736 11.3047 -0.0870148 11.6417 0.239785C11.9528 0.541447 11.9838 1.02317 11.7297 1.36057L11.6602 1.44172L4.24083 9.09297L0.231032 4.83256C-0.0907066 4.49071 -0.0744053 3.95277 0.267442 3.63103C0.582994 3.33404 1.06563 3.32508 1.39107 3.59434L1.46897 3.66744L4.25935 6.6317L10.4398 0.258277Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.100706a2.svg";
export { ForwardRef as ReactComponent };